import React, { useEffect, useState } from 'react';
import "./AddressField.css";

const AddressField = ({ label1, infoKey = "", name1, value1, placeholder1, label2, name2, value2, placeholder2, setCallback, householdAddress = false }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className='row my-2 d-flex justify-content-start addressField'>
      <div className={`col-8 col-sm-8 col-md-8 ${householdAddress ? "householdAddressField" : ""}`}>
        <input
          className={`${screenWidth>=768?"col-11":"col-12"} text-md address-form-control field-left`}
          type="text"
          name={`${infoKey ? infoKey + "_" : ""}${name1}`}
          value={value1}
          placeholder={placeholder1}
          onChange={(e) => setCallback(label1, e.target.value, infoKey)}
        />
      </div>
      <div className={`col-4 col-sm-4 col-md-4`}>
        <input
          className="col-12 text-sm address-form-control field-right"
          maxLength={5}
          type="text"
          name={`${infoKey ? infoKey + "_" : ""}${name2}`}
          value={value2}
          placeholder={placeholder2}
          onChange={(e) => setCallback(label2, label2 == "Zip *"?e.target.value.replace(/\D/g, ""): e.target.value.replace(/[^a-zA-Z0-9]/g, ""), infoKey)}
        />
      </div>
    </div>
  )
}

export default AddressField
